import "./styles.less";

import { Button, Checkbox, Col, Form, Row, Tooltip, Typography, notification } from "antd";
import React, { useState } from "react";
import { ReportPropertyProps, useReportProperty } from "./hook";

import { FlagOutlined } from "@ant-design/icons";
import Modal from "antd/lib/modal/Modal";
import { useTheme } from "../../../Styles/ThemeHook";

const { useForm } = Form;

export const ReportButton = ({
	id,
	mode = "property",
	isEspecial,
	isDisabledProperty = false,
}: ReportPropertyProps) => {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const { options, reasons, sendReport } = useReportProperty({ id, mode });
	const [modal, setModal] = useState(false);
	const [tooltip, setTooltip] = useState(false);
	const { theme } = useTheme();
	const [form] = useForm();

	return (
		<>
			<Tooltip
				title={mode == "project" ? "Denunciar Proyecto" : "Denunciar Propiedad"}
				trigger={"hover"}
				visible={!isDisabledProperty && tooltip && !modal}
				onVisibleChange={e => setTooltip(e)}>
				<Button
					disabled={isDisabledProperty}
					icon={<FlagOutlined className="report-icon" />}
					className={`report-button secondary ${isEspecial ? "isEspecial" : ""}`}
					onClick={() => {
						setModal(true);
						setTooltip(false);
					}}
					children={!isEspecial ? "Reportar" : null}
				/>
			</Tooltip>
			<Modal
				className={"report-property-modal"}
				visible={modal}
				centered
				title={
					<Typography.Title
						children={
							mode == "project" ? "Reportar Proyecto" : "Reportar Propiedad"
						}
						level={4}
						style={{ margin: 0 }}
					/>
				}
				onOk={() => {
					form.validateFields()
						.then(data => {
							sendReport()
								.then(() => {
									setModal(false);
									handleClickShowNotification({
										message: "Denuncia Enviada",
										description: "La denuncia ha sido enviada correctamente. ",
									});
								})
								.catch(er => {
									setModal(false);
									handleClickShowNotification({
										message: "Denuncia Cancelada",
										description: "Hubo un error al enviar las denuncia.",
										type: "error",
									});
								});
						})
						.catch(er => { });
				}}
				okText={"Reportar"}
				okButtonProps={{ className: "secondary", type: "primary" }}
				onCancel={() => setModal(false)}
				cancelText={""}
				cancelButtonProps={{ style: { display: "none" } }}
				closable
				maskClosable
				children={
					<Form form={form}>
						<Form.Item
							rules={[
								{
									required: true,
									message: "Seleccione una razón para reportar la propiedad",
								},
							]}
							name={"reasons"}>
							<Checkbox.Group value={reasons.value} onChange={e => reasons.set(e)}>
								<Row gutter={[0, theme.spacing.mdSpacing]}>
									{options?.map(o => (
										<Col span={24} key={`key_${o["id"]}_bathrooms`}>
											<Checkbox value={o["id"]}>{o["text"]}</Checkbox>
										</Col>
									))}
								</Row>
							</Checkbox.Group>
						</Form.Item>
					</Form>
				}
			/>
		</>
	);
};
